import React from 'react';

import { Button } from '@edx/components/button';
import { Title } from '@edx/components/typography';
import { useBillingInformationQuery } from '@edx/graphql/generated';

export const EnrollBanner: React.FC = () => {
  const { data } = useBillingInformationQuery();
  const monthlyFormattedPrice = data?.billingInformation.plans?.find(({ interval }) => interval === 'MONTHLY')
    ?.priceFormatted;

  return (
    <div
      className="relative flex justify-center border-t border-b border-gray-600 border-opacity-50"
      style={{
        backgroundImage: "url('/img/newsletter/newsletter-bg.png')",
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'bottom',
        backgroundColor: '#212121',
      }}
    >
      <div className="absolute inset-0 bg-gray-800 bg-opacity-50" />

      <div className="relative w-full max-w-3xl mx-auto flex flex-col md:flex-row items-center justify-center md:justify-between py-10 sm:py-14 md:py-20 space-y-4 md:space-y-0 px-4">
        <Title tag="h3" size="small" className="text-center md:text-left text-gray-300">
          Aprende a tocar el bajo desde sólo {monthlyFormattedPrice} al mes
        </Title>
        <Button href="/precio" size="xlarge" textVariant="medium">
          Regístrate ahora
        </Button>
      </div>
    </div>
  );
};
